/**
 * Table utility functions for shared use across the application
 */

/**
 * Determines if a column in a table is numeric based on the content of its cells
 * @param {Array} rows - Array of table rows (each row is an array of cell values)
 * @param {number} columnIndex - Index of the column to check
 * @returns {boolean} - True if more than 50% of non-empty values in the column are numeric
 */
export const isColumnNumeric = (rows, columnIndex) => {
  // Check if most values in this column are numeric
  let numericCount = 0
  let totalCount = 0

  for (const row of rows) {
    if (row[columnIndex] !== undefined && row[columnIndex] !== null && row[columnIndex] !== '') {
      totalCount++
      if (/^[\d,.-]+$/.test(row[columnIndex].toString().trim())) {
        numericCount++
      }
    }
  }

  // Consider column numeric if more than 50% of non-empty values are numeric
  return totalCount > 0 && numericCount / totalCount > 0.5
}
